export const OPEN_WORD_VIEWER = "OPEN_WORD_VIEWER";
export const CLOSE_WORD_VIEWER = "CLOSE_WORD_VIEWER";
